import { CART_API } from "../constants/api";
import { CancelSOServiceParamModel, DeleteServiceParamModel, GetCartAvailableDateByAddressModel, GetCartServiceParamModel, GetCartsParamsModel, GetCartsServiceParamModel, GetFutureOrderParamsModel, GetFutureOrderServiceParamModel, PlaceCartParamModel, ValidateServiceParamModel } from "../model/cart";
import { getHeadersWithTokenAndTraderId, getUrl, optionsGet, optionsPost } from "./commonService";
import customAxios from "./customAxios";

export default class CartService {

  getCartDefaultAddressService(params: any) {

    const url = getUrl(CART_API.CART_DEFAULT_ADDRESSID);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }


  getFirstAvailableDateByAddressService(params: GetCartAvailableDateByAddressModel) {
    let api = CART_API.CART_AVAIL_DATE_BY_ADDRESS;
    api = api.replace("#ADDRESSID#", params.cartDefAddressId.toString());

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers)

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

 
  getCartService(params: GetCartServiceParamModel) {
    let api = CART_API.GET_CART;
    api = api.replace("#ADDRESSID#", params.getCartParams.addressId ? params.getCartParams.addressId.toString() : "0");
    api = api.replace("#DATE#", params.getCartParams.date);
    api = api.replace("#SOAMMEND#", params.getCartParams.soAmend.toString());
    api = api.replace("#ISSAMEDAYORDER#", params.getCartParams.isSameDayOrder?params.getCartParams.isSameDayOrder.toString():"false");
    api = api.replace("#ISLATE#", params.getCartParams.isLate?params.getCartParams.isLate.toString():"false");
    api = api.replace("#SEQUENCE#", params.getCartParams.sequence?params.getCartParams.sequence.toString():"0");
    api = api.replace("#ID#", params.getCartParams.id ? params.getCartParams.id.toString() : "");
    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params.headerParams);
    const options: any = optionsGet(url, headers)

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  getCartsService(params: GetCartsServiceParamModel) {
    let api = CART_API.GET_CARTS;
    api = api.replace("#ADDRESSID#", params.getCartsParams.addressId.toString());
    api = api.replace("#DATE#", params.getCartsParams.date);
    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params.headerParams);
    const options: any = optionsGet(url, headers)

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  placeCartService(params: PlaceCartParamModel) {

    const url = getUrl(CART_API.PLACE_CART);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsPost(url, headers, params.detail)

    return customAxios(options).then((res) => {
      return res.data;
    });


  }

  deleteCartService(params: DeleteServiceParamModel) {

    const url = getUrl(CART_API.DELETE_CART);
    const headers = getHeadersWithTokenAndTraderId(params.headerParams);
    const options: any = optionsPost(url, headers, params.deleteParams.detail)

    return customAxios(options).then((res) => {
      return res.data;
    });


  }



  cancelSOService(params: CancelSOServiceParamModel) {

    const url = getUrl(CART_API.CANCEL_SOCART);
    const headers = getHeadersWithTokenAndTraderId(params.headerParams);
    const options: any = optionsPost(url, headers, params.cancelSOParams.detail)

    return customAxios(options).then((res) => {
      return res.data;
    });


  }



  getFutureOrderService(params: GetFutureOrderServiceParamModel) {
    let api = CART_API.FUTURE_ORDERS;
    api = api.replace("#ADDRESSID#", params.getFutureOrderParams.addressId ? params.getFutureOrderParams.addressId.toString() : "0");
    api = api.replace("#DATE#", params.getFutureOrderParams.date);
    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params.headerParams);
    const options: any = optionsGet(url, headers)

    return customAxios(options).then((res) => {
      return res.data;
    });
  }




}


